import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_FORMAT_SHOW } from "src/utils/constants"
import ParameterPaginationTable from "../../../../components/table/parameter-pagination-table"

const ParameterDatalakeRatingDevedorTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "DataValidade": dayjs().format(DATE_FORMAT),
            "CPFCNPJ" : "N/A",
            "Devedor": "N/A",
            "Setor": "N/A",
            "SubSetor": "N/A",
            "Fonte": "N/A",
            "ScoreRating": 0,
            "Rating": "N/A",
            "Sinal": "N/A",
            "Perspectiva": "N/A",
            "Observacao": "N/A",
            "AnaliseCreditoDevedor": "N/A"
        }

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, DataReferencia, DataValidade, CPFCNPJ, Devedor, Setor, SubSetor, Fonte,
            ScoreRating, Rating, Sinal, Perspectiva, Observacao, AnaliseCreditoDevedor
        } = newRow

        const body = {
            "DataReferencia": DataReferencia,
            "DataValidade": DataValidade,
            "CPFCNPJ" : CPFCNPJ,
            "Devedor": Devedor,
            "Setor": Setor,
            "SubSetor": SubSetor,
            "Fonte": Fonte,
            "ScoreRating": ScoreRating,
            "Rating": Rating,
            "Sinal": Sinal,
            "Perspectiva": Perspectiva,
            "Observacao": Observacao,
            "AnaliseCreditoDevedor": AnaliseCreditoDevedor
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }


    const columns = [
        {
            field: 'ID',
            headerName: '#',
            flex: true,
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true,
            typeComponent: 'date'
        },
        {
            field: 'DataValidade',
            headerName: 'DataValidade',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            editable: true
        },

        {
            field: 'CPFCNPJ',
            headerName: 'CPFCNPJ',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'Devedor',
            headerName: 'Devedor',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'Setor',
            headerName: 'Setor',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'SubSetor',
            headerName: 'SubSetor',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'Fonte',
            headerName: 'Fonte',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'ScoreRating',
            headerName: 'ScoreRating',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            editable: true
        },
        {
            field: 'Rating',
            headerName: 'Rating',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'Sinal',
            headerName: 'Sinal',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'Perspectiva',
            headerName: 'Perspectiva',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'Observacao',
            headerName: 'Observacao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'AnaliseCreditoDevedor',
            headerName: 'AnaliseCreditoDevedor',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => dayjs(params.value).format(DATE_FORMAT_SHOW),
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => dayjs(params.value).format(DATE_FORMAT_SHOW),
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true}
                 />
        </div>
    )
}

ParameterDatalakeRatingDevedorTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeRatingDevedorTable
